import classnames from 'classnames';
import React from 'react';

import type { LayoutProps } from '../LayoutTypes';
import LayoutContainer from '../base/LayoutContainer';

export const LargeCenteredContainer: React.FC<LayoutProps> = ({
    layoutClassNames,
    itemClassNames,
    backgroundColor,
    gridSeperatorSize,
    whiteSpaceNone = false,
    children,
}) => (
    <LayoutContainer
        layoutClassNames={classnames('large-centered-container', layoutClassNames)}
        itemClassNames={itemClassNames}
        backgroundColor={backgroundColor}
        gridSeperatorSize={gridSeperatorSize}
        whiteSpaceNone={whiteSpaceNone}
    >
        {children}
    </LayoutContainer>
);

export const MediumCenteredContainer: React.FC<LayoutProps> = ({
    layoutClassNames,
    itemClassNames,
    backgroundColor,
    gridSeperatorSize,
    whiteSpaceNone = false,
    children,
}) => (
    <LayoutContainer
        layoutClassNames={classnames('medium-centered-container', layoutClassNames)}
        itemClassNames={itemClassNames}
        backgroundColor={backgroundColor}
        gridSeperatorSize={gridSeperatorSize}
        whiteSpaceNone={whiteSpaceNone}
    >
        {children}
    </LayoutContainer>
);

// @deprecated use LargeCenteredContainer with backgroundcolor instead
export const FormContainer: React.FC<LayoutProps> = ({
    layoutClassNames,
    itemClassNames,
    backgroundColor,
    gridSeperatorSize,
    whiteSpaceNone = false,
    children,
}) => (
    <LayoutContainer
        layoutClassNames={classnames('form-container', layoutClassNames)}
        itemClassNames={itemClassNames}
        backgroundColor={backgroundColor}
        gridSeperatorSize={gridSeperatorSize}
        whiteSpaceNone={whiteSpaceNone}
    >
        {children}
    </LayoutContainer>
);
